import { API_ENDPOINTS } from "@/api/services/holiday/apiEndpoints";
import { baseApi } from "@/utils/baseApi";
export const allHolidaysApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchAllHolidays: builder.query({
      query: ({ month, state, location, type } = {}) => ({
        url: API_ENDPOINTS.ALL_HOLIDAY.FETCH_ALL_HOLIDAYS(month, state, location, type),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "holidays", id: "LIST" }],
    }),

    fetchSettings: builder.query({
      transformResponse: (response) => response?.data,
      query: ({ referenceName }) => ({
        url: API_ENDPOINTS.ALL_HOLIDAY.FETCH_SETTINGS({ referenceName }),
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [{ type: "holidays", id: "LIST" }]
          : [{ type: "holidays", id: "LIST" }],
    }),
    fetchState: builder.query({
      transformResponse: (response) => response?.data,
      query: () => ({
        url: API_ENDPOINTS.ALL_HOLIDAY.FETCH_STATE(),
        method: "GET",
      }),
      providesTags: (result) =>
        result
          ? [{ type: "holidays", id: "LIST" }]
          : [{ type: "holidays", id: "LIST" }],
    }),
  }),
});

export const { useFetchAllHolidaysQuery, useFetchSettingsQuery, useFetchStateQuery } = allHolidaysApi;
